import secondaryComponents from "../../../../../../components/secondaryComponents";
import { motion } from "framer-motion";
import globalStyles from "../../../../../../assets/styles/base/globalPage.module.scss";
import { PurchaseOrderForm } from "../../../../../../components/secondaryComponents/PurchaseOrder";
import { useEditPurchaseOrder } from "./useEditPurchaseOrder";
import { BackButton } from "../../../../../../components/primaryComponents";

export const EditPurchaseOrder = () => {
  const { isLoading, PODetails, POItems } = useEditPurchaseOrder();

  return (
    <secondaryComponents.MetaSetter
      title="Lumi Merchant | Update Purchase Orders"
      description="Update purchase order that was created in the past."
    >
      <secondaryComponents.RequestLoaderTrigger>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className={`${globalStyles.pageColumnGaps}`}
        >
          <div className="d-flex align-items-center">
            <BackButton />
            <h4 className="ml-2 mb-0">
              <span className="gray--text">PO NO.: </span>{" "}
              {PODetails?.po_number}
            </h4>
          </div>

          <secondaryComponents.LoaderHelper
            classNames={"mt-5"}
            isLoading={isLoading}
          >
            <PurchaseOrderForm
              PODetails={PODetails}
              POItems={POItems}
              isEditMode={true}
            />
          </secondaryComponents.LoaderHelper>
        </motion.div>
      </secondaryComponents.RequestLoaderTrigger>
    </secondaryComponents.MetaSetter>
  );
};
